export default __webpack_public_path__ + "static/media/filters.6fd3e699.svg";